import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_adminLayout/admin/parts/feed-import")({
  beforeLoad: () => {
    throw redirect({ href: "/admin/feed-import" });
  },
});
